<template>
  <div>
    <div
      class='clearfix yxt-user-advance-wrap pr20'
    >
      <yxt-row onsubmit='return false' class="mb16" type='flex'>
        <yxt-form
          style='flex:1'
          :inline='true'
        >
          <div class='d-in-flex'>
            <yxt-popover
              :append-to-body='false'
              popper-class='yxtbiz-user-selector-popover'
              trigger='manual'
              placement='bottom-start'
              :visible-arrow='false'
              v-model='showMoreFilter'
            >
              <yxt-button
                slot='reference'
                plain
                @click.stop='showFilterBox'
                class='yxtbiz-filter-btn mr12 pull-left'
              >
                <yxt-svg
                  width='20px'
                  height='20px'
                  icon-class='filter'
                  class='v-top'
                />
                <span class='ml8 v-top'>{{$t('pc_biz_udp_lbl_moreFilter')}}</span>
                <i
                  class='ml8'
                  :class='showMoreFilter ? "yxt-icon-arrow-up": "yxt-icon-arrow-down"'
                ></i>
              </yxt-button>
              <yxt-form
                :inline='true'
                class='yxtbiz-user-selector-filter'
                label-position="top"
              >
                <div style="width:950px;max-height: 600px;overflow: auto;">
                  <div
                    class='yxtbiz-user-selector-filter-box clearfix'
                    style='width:950px;'
                  >
                    <div class='pl20 yxtbiz-user-selector-filter-right yxtbiz-user-selector-filter-block'>
                      <yxt-row :gutter='20'>
                        <yxt-col v-if="isShowDeptment" :span='12'>
                          <yxt-form-item
                            style='width: 100%'
                            :label="$t('biz_udp_deptment')"
                          >
                          <tree-select
                            :placeholder='$t("pc_biz_udp_lbl_unlimitedPosition")'
                            style='width: 220px;'
                            @click.native='showTree("dept-tree")'
                            v-model='depts'
                            @remove-tag='removeDept'
                          ></tree-select>
                          </yxt-form-item>
                        </yxt-col>
                        <yxt-col :span='12'>
                          <yxt-form-item
                            style='width: 100%'
                            :label="$t('biz_udp_position')"
                          >
                            <tree-select
                              :placeholder="$t('biz_udp_no_limit_pos')"
                              @click.native='showPosition'
                              v-model='positions'
                              @remove-tag='removePostion'
                            ></tree-select>
                          </yxt-form-item>
                        </yxt-col>
                        <yxt-col
                          :span='12'
                          v-for='(item, index) in selectedParams'
                          :key='index'
                        >
                          <yxt-form-item
                            style='width: 100%'
                            :label='item.label'
                          >
                            <div>
                              <component
                                :enableGroupCorp='enableGroupCorp'
                                v-bind='item.props'
                                :is='item.component'
                                v-model='item.data'
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                @input='itemChange($event)'
                              />
                            </div>
                          </yxt-form-item>
                        </yxt-col>
                        <!-- 高级选人筛选字段支持扩展字段 -->
                        <spare-item
                          v-for="(item,key) in spares"
                          :key="'spareitem_'+key"
                          :name="item.name"
                          :type="item.patternType"
                          :list="item.list"
                          :value.sync="item.patternValues"
                        />
                        <yxt-col :span='24'>
                          <yxt-form-item label=' '>
                            <yxt-button
                                @click='filterSearch'
                                type='primary'
                              >{{$t('pc_biz_udp_btn_determine')}}</yxt-button>
                              <yxt-button
                                @click='closeFilterBox'
                                plain
                                class="mr8"
                                type='default'
                              >{{$t('pc_biz_udp_btn_cancel')}}</yxt-button>
                              <yxt-button
                                :disabled='saveDisabled'
                                type='text'
                                @click='showFilter'
                              >{{$t('pc_biz_udp_btn_saveToCommon')}}</yxt-button>
                          </yxt-form-item>
                        </yxt-col>
                      </yxt-row>
                    </div>
                  </div>
                </div>
              </yxt-form>
            </yxt-popover>
            <yxtbiz-group-org-select 
              @change='handleOrgChange'
              :functionCode="functionCode"
              :dataPermissionCode="dataPermissionCode"
              @orgInvalid="orgInvalidHandler"
              v-if='enableGroupCorp'  
              :selectFirst="true"
              :clearable="false"
              :disabled="disabled"
              :setCurrentOrg="true"
              :targetOrgId="targetOrgId"
              :visibleOrgIds="visibleOrgIds"
              :disabledOrgIds="disabledOrgIds">
            </yxtbiz-group-org-select>
            <yxt-input
              :placeholder="$t('pc_biz_udp_tip_searchCommon')"
              v-model='searchValue'
              class='ml12'
              style='width: 190px;'
              searchable
              @search='search'
            ></yxt-input>
          </div>
        </yxt-form>
        <div class='lh40'>
          <yxt-dropdown
            :append-to-body='false'
            trigger='click'
            @command='selectFilter'
          >
            <span
              @click='closeFilterBox'
              class='yxt-dropdown-link yxt-link yxt-link--primary'
            >{{$t('pc_biz_udp_lbl_commonFilters')}}</span>
            <yxt-dropdown-menu
              slot='dropdown'
              style='overflow:hidden'
            >
              <yxt-dropdown-item
                disabled
                v-if='filterList.length === 0'
              >{{$t('pc_biz_udp_tip_noFilters')}}</yxt-dropdown-item>
              <yxt-dropdown-item
                :key='item.id'
                :command='item'
                v-for='item in filterList'
              >
                <yxt-row
                  type='flex'
                  align='middle'
                  class='yxt-selector-filter-row'
                  style='width: 100%'
                >
                  <div class='yxt-selector-filter-name'>
                    <span>{{ item.name }}</span>
                  </div>
                  <span
                    class='yxt-icon-close'
                    @click.stop='deleteFilter(item)'
                  ></span>
                </yxt-row>
              </yxt-dropdown-item>
            </yxt-dropdown-menu>
          </yxt-dropdown>
        </div>
      </yxt-row>
      <yxt-table
        ref='userTable'
        @select-all='selectAllUser'
        @select='selectUser'
        :height='tableHeight'
        v-loading='loading'
        class='yxt-user-table'
        row-key="id"
        :data='users'
      >
        <template slot='empty'>
          <div style='line-height:normal'>
            <yxt-empty />
          </div>
        </template>
        <yxt-table-column
          :show-overflow-tooltip='false'
          class-name='yxtbiz-table-selection'
          type='selection'
          width='40'
        ></yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_core_lbl_name')" :show-overflow-tooltip="true" popover-html>
          <template slot-scope='scope'>
            <yxtbiz-user-name v-if='isOpenData' :name='scope.row.fullname' />
            <span v-else>{{ scope.row.fullname + '(' + scope.row.username + ')' }}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column
          :show-overflow-tooltip="true"
          :formatter='formatUserNo'
          :label='$t("pc_biz_core_lbl_userNo")'
          prop='userNo'
        ></yxt-table-column>
        <yxt-table-column :label="$t('pc_biz_core_lbl_department')" :show-overflow-tooltip="true" :popover-html="true">
          <template slot-scope="scope">
            <span v-if="!scope.row.deptName">--</span>
            <yxtbiz-dept-name v-else-if='isOpenData' :name='scope.row.deptName' />
            <span v-else>{{scope.row.deptName}}</span>
          </template>
        </yxt-table-column>
        <yxt-table-column
          :label='$t("biz_udp_position")'
          :show-overflow-tooltip="true"
          :formatter='formatPostion'
        ></yxt-table-column>
      </yxt-table>
      <yxt-row type='flex' align='middle' class='yxtbiz-user-selector-mask mt16'>
        <yxt-row class="col-flex-1" type='flex' align='middle'>
           <yxt-button
              class='lh32 yxtbiz-btn-search-all'
              :class="isSearchAll ? 'color-primary-4 disabled' : ''"
              type='text'
              v-if="showFilterAll"
              @click='searchAll'
            >{{ isCancelSelect ? $t('pc_biz_udp_btn_cancelFilter') : $t('biz_udp_all_filter_results') }}</yxt-button><div class="yxtbiz-loading__all" v-loading="isSearchAll"></div>
        </yxt-row>
        <yxt-pagination
          class='pull-right'
          @size-change='sizeChange'
          @current-change='pageChange'
          :current-page.sync='page'
          :page-size='userData.limit'
          simple-total
          layout='total, prev, pager, next'
          :total='count'
        ></yxt-pagination>
      </yxt-row>
    </div>
    <yxt-drawer
      :title='$t("pc_biz_udp_tit_saveFilter")'
      :modal='false'
      :visible.sync='dialogVisible'
      size='480px'
    >
      <yxt-form>
        <yxt-form-item
          label-width='80px'
          :label='$t("pc_biz_udp_lbl_filterName")'
        >
          <yxt-input
            maxlength='100'
            v-model='filerName'
          ></yxt-input>
        </yxt-form-item>
      </yxt-form>
      <div slot='footer'>
        <yxt-button
          plain
          @click='dialogVisible = false'
        >{{$t('pc_biz_udp_btn_cancel')}}</yxt-button>
        <yxt-button
          type='primary'
          @click='saveFilter'
        >{{$t('pc_biz_udp_btn_confirm')}}</yxt-button>
      </div>
    </yxt-drawer>
    <yxt-drawer
      :title='$t("biz_udp_select_dept")'
      :destroy-on-close='true'
      size='480px'
      :visible.sync='drawerVisible'
    >
      <div class="yxtbiz-dept-tree-full-height">
        <component
          :enableGroupCorp='true'
          :targetOrgId="userData.targetOrgId"
          :visibleOrgSelector='false'
          ref='tree'
          v-bind='treeProps'
          :is='component'
        ></component>
      </div>
      <div slot='footer'>
        <yxt-button
          plain
          @click='cancelTree'
        >{{$t('pc_biz_udp_btn_cancel')}}</yxt-button>
        <yxt-button
          type='primary'
          @click='confirmTree'
        >{{$t('pc_biz_udp_btn_confirm')}}</yxt-button>
      </div>
    </yxt-drawer>
    <yxt-drawer
      :title='$t("pc_biz_udp_tit_selectPotision")'
      :visible.sync='positionVisible'
      :destroy-on-close='true'
      size='960px'
    >
      <yxtbiz-check-person-range
        v-if="enableGroupCorp && userData.targetOrgId"
        :targetOrgId="userData.targetOrgId"
        :enableGroupCorp='true'
        :visibleOrgSelector='false'
        :personRange.sync='selectedPositions'
        :functionCode='functionCode'
        :dataPermissionCode='dataPermissionCode'
        :tabs="['position']"
      ></yxtbiz-check-person-range>
       <yxtbiz-check-person-range
        v-if="!enableGroupCorp"
        :personRange.sync='selectedPositions'
        :functionCode='functionCode'
        :dataPermissionCode='dataPermissionCode'
        :tabs="['position']"
      ></yxtbiz-check-person-range>
      <div
        slot='footer'
        class='dialog-footer'
      >
        <yxt-button
          plain
          @click='positionVisible = false'
        >{{$t('pc_biz_udp_btn_cancel')}}</yxt-button>
        <yxt-button
          type='primary'
          @click='closePosition'
        >{{$t('pc_biz_udp_btn_confirm')}}</yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
import {
  createFilter,
  getFilterList,
  deleteFilter,
  editFilter,
  getUserList,
  getFilterDetail,
  getOrgSparsByUser
} from '../service';
import deptTree from '../../../dept-tree';
import posTree from '../../../pos-tree';
import treeSelect from './tree-select';
import DateRange from './dateRange';
import Sex from './sex';
import Grade from './grade';
import resizeTable from '../../mixins/resizeTable';
import { Form, FormItem, Drawer, DatePicker, Table, TableColumn, Empty, Pagination, Popover } from 'yxt-pc';
import CheckPersonRange from 'yxt-biz-pc/packages/check-person-range';
import openDataMixin from '../../mixins/openData';
import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';
import groupMixin from '../../mixins/group';
import SpareItem from './spareItem';

export default {
  components: {
    deptTree,
    treeSelect,
    posTree,
    Sex,
    DateRange,
    Grade,
    YxtForm: Form,
    YxtFormItem: FormItem,
    YxtDrawer: Drawer,
    YxtDatePicker: DatePicker,
    YxtTable: Table,
    YxtTableColumn: TableColumn,
    YxtEmpty: Empty,
    YxtPagination: Pagination,
    YxtbizCheckPersonRange: CheckPersonRange,
    YxtPopover: Popover,
    SpareItem
  },
  mixins: [resizeTable, openDataMixin, groupMixin],
  props: {
    value: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'persons'
    },
    scope: {
      type: Number
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    isShowDeptment: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedParams: [],
      selectedPositions: [],
      isSearchAll: false,
      orgInvalid: false, // 是否全部禁用，如果机构全部禁用了，则不能搜索
      refTable: 'userTable',
      showMoreFilter: false,
      loading: false,
      component: '',
      treeProps: {},
      drawerVisible: false,
      users: [],
      count: 0,
      searchValue: '',
      filterId: '',
      dialogVisible: false,
      depts: [],
      filterList: [],
      positions: [],
      deptObj: {},
      positionObj: [],
      filerName: '', // 筛选器名称
      positionVisible: false,
      isCancelSelect: false,
      showFilterAll: false, // 是否显示筛选所有
      params: [
        {
          label: i18n.t('biz_udp_occupation_level'),
          type: 'treeSelect',
          db: 'gradeIds',
          data: [],
          component: 'Grade'
        },
        // {
        //   label: '工号',
        //   type: 'text',
        //   db: 'userNo',
        //   data: '',
        //   component: 'yxtInput'
        // },
        // {
        //   label: '手机号',
        //   type: 'text',
        //   component: 'yxtInput',
        //   db: 'mobile',
        //   data: ''
        // },
        // {
        //   label: '邮箱',
        //   type: 'text',
        //   component: 'yxtInput',
        //   db: 'email',
        //   data: ''
        // },
        {
          label: i18n.t('pc_biz_enroll_lbl_entrydate'),
          db: 'hireDate',
          data: {
            start: '',
            end: ''
          },
          component: 'YxtDatePicker',
          props: { type: 'daterange' },
          type: 'dateRange'
        },
        {
          label: i18n.t('biz_udp_lbl_dateofbirth'),
          type: 'dateRange',
          data: {
            start: '',
            end: ''
          },
          component: 'YxtDatePicker',
          props: { type: 'daterange' },
          db: 'birthday'
        },
        {
          label: i18n.t('pc_biz_core_lbl_gender'),
          db: 'sex',
          type: 'sex',
          data: 0,
          component: 'Sex'
        }
      ],
      totalPage: 0,
      tableHeight: 0,
      page: 1,
      userData: {
        scope: this.scope,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode,
        searchKey: '',
        type: 3,
        limit: 20,
        offset: 0
      },
      selectedPersons: {},
      formatPostion: row => {
        if (row.positionName === undefined) {
          return (
            row.positionSet
              .map(item => {
                return item.name;
              })
              .join(';') || '--'
          );
        } else {
          const parttimePosition = row.parttimePositionSet ? Array.from(row.parttimePositionSet) : [];
          const posList = parttimePosition.map(item => item.name);
          posList.push(row.positionName || '');
          return posList.filter(item => item !== '').join(';') || '--';
        }
      },
      formatUserNo: row => {
        return row.userNo || '--';
      },
      spares: [],
      spareForm: {
      }
    };
  },
  created() {
    this.selectedParams = this.formatSelectedFromData(this.params);
    this.getOrgSpares();
    this.getFilterList();
    this.formatUsers(this.value);
    if (!this.enableGroupCorp || this.targetOrgId) {
      if (this.targetOrgId) this.userData.targetOrgId = this.targetOrgId;
      this.getUserData();
    }
  },
  computed: {
    postData() {
      let result = {};
      this.selectedParams.forEach(item => {
        if (item.type === 'sex') {
          result.sex = item.data;
        } else if (item.type === 'dateRange') {
          if (item.data) {
            result[item.db + 'Start'] = item.data[0];
            result[item.db + 'End'] = item.data[1];
          } else {
            result[item.db + 'Start'] = '';
            result[item.db + 'End'] = '';
          }

        } else if (item.db === 'gradeIds') {
          result.gradeIds = item.data;
        } else {
          result[item.db] = item.data;
        }
      });
      /* eslint-disable no-undef */
      result.deptIds = Array.from(new Set(this.depts.map(dept => dept.id).filter(id => id !== '')));
      // result.deptSearchList = result.deptIds.map(id => {
      //   return {
      //     deptId: id,
      //     includeSubDept: 0 // 高级选人不包含下级部门
      //   };
      // });
      result.includeSubDept = 0; // 不包含子部门
      result.positionIds = this.positions
        .map(position => position.id)
        .filter(id => id !== '');
      result.name = this.filerName;
      return result;
    },
    saveDisabled() {
      const spareHasValue = this.spares.some(i=>!!i.patternValues.length);
      const keys = ['birthdayEnd', 'birthdayStart', 'deptIds', 'gradeIds', 'hireDateEnd', 'hireDateStart', 'positionIds', 'sex'];
      return !spareHasValue && !keys.some(key => {
        return (this.postData[key] && !(this.postData[key] instanceof Array)) || (this.postData[key] instanceof Array && this.postData[key].length > 0) || (key === 'sex' && this.postData[key] !== 0);
      });
    }
  },
  methods: {
    // 无可用机构-数据置空
    orgInvalidHandler() {
      this.orgInvalid = true;
      this.users = [];
      this.totalPage = 0;
      this.count = 0;
    },
    handleOrgChange(data) {
      this.orgInvalid = false;
      this.userData.targetOrgId = data.orgId;
      this.userData.targetOrgName = data.orgName;
      this.selectedParams[0].data = [];
      this.depts = [];
      this.positions = [];
      this.search();
    },
    formatUsers(users) {
      this.selectedPersons = {};
      users.forEach(user => {
        this.selectedPersons[user.id] = user;
      });
    },
    showPosition() {
      this.selectedPositions = this.positions.map(i => {
        i._type = 1;
        return i;
      });
      this.positionVisible = true;
    },
    closePosition() {
      this.positions = this.selectedPositions.slice();
      this.positionVisible = false;
    },
    showTree(component) {
      this.treeProps = {
        filterable: true,
        'check-strictly': true,
        'show-checkbox': true,
        'functions': true,
        'wrap-width': '100%',
        'functionCode': this.functionCode,
        'dataPermissionCode': this.dataPermissionCode,
        'childrenIncluded': 2
      };

      if (component === 'pos-tree') {
        this.treeProps['catalog-only'] = false;
        this.treeProps['default-checked-keys'] = this.postData.positionIds;
      } else {
        this.treeProps['default-checked-keys'] = this.postData.deptIds;
      }
      this.component = component;
      this.drawerVisible = true;
    },
    confirmTree() {
      switch (this.component) {
        case 'dept-tree':
          this.depts = this.$refs.tree.getCheckedNodes();
          break;
        case 'pos-tree':
          this.positions = this.$refs.tree.getCheckedNodes();
          break;
        case 'Grade':
          break;
        default:
          break;
      }
      this.drawerVisible = false;
    },
    cancelTree() {
      this.drawerVisible = false;
      this.component = '';
      this.treeProps = {};
      this.drawerVisible = false;
    },
    showFilterBox() {
      this.showMoreFilter = !this.showMoreFilter;
    },
    closeFilterBox() {
      this.showMoreFilter = false;
    },
    filterSearch() {
      this.showMoreFilter = false;
      this.search();
    },
    getFilterList() {
      getFilterList(this.enableGroupCorp).then(result => {
        this.filterList = result.datas;
      });
    },
    removeDept(dept) {
      this.depts = this.depts.filter(item => item.id !== dept.id);
    },
    removePostion(position) {
      this.positions = this.positions.filter(item => item.id !== position.id);
    },
    isParamsEmpty(userData) {
      const arrarykeys = ['positionIds', 'gradeIds', 'deptIds'];
      const strKeys = ['birthdayEnd', 'birthdayStart', 'hireDateEnd', 'hireDateStart', 'searchKey', 'sex'];
      let isEmpty = true;
      for (let i = 0; i < arrarykeys.length; i++) {
        if (userData[arrarykeys[i]].length !== 0) {
          isEmpty = false;
          break;
        }
      }

      if (!isEmpty) {
        for (let i = 0; i < strKeys.length; i++) {
          if (userData[strKeys[i]]) {
            isEmpty = false;
            break;
          }
        }
      }
      return isEmpty;
    },
    getUserData() {
      if (this.orgInvalid) return;
      const userData = Object.assign({}, this.userData, this.postData, {dynamicSearch: JSON.parse(JSON.stringify(this.spares))});
      // 把 dynamicSearch 数组中的list字段去除掉
      userData.dynamicSearch.forEach(item => delete item.list);
      delete userData.name; // 查找人不需要筛选器名字
      this.userData = userData;
      this.loading = true;
      this.isCancelSelect = false;
      getUserList(userData, this.enableGroupCorp).then(result => {
        if (this.orgInvalid) return;
        if (result.datas.length !== 0) {
          // 搜索条件不为空，展示筛选全部按钮
          this.showFilterAll = true;
        } else {
          this.showFilterAll = false;
        }
        this.loading = false;
        this.users = result.datas;
        this.users.forEach(user => {
          user.nodeType = this.type;
        });
        this.totalPage = result.paging.pages;
        this.count = result.paging.count;
        this.loading = false;
        this.$nextTick(() => {
          this.checkStatus();
        });
      }).catch(() => {
        this.users = [];
        this.loading = false;
      });
    },
    cancelSelectAll() {
      getUserList(Object.assign({}, this.userData, {offset: 0, limit: this.count}))
        .then(res => {
          this.isCancelSelect = false;
          const list = res.datas;
          list.forEach(user => {
            if (this.enableGroupCorp) {
              user.orgId = this.userData.targetOrgId;
              user.orgName = this.userData.targetOrgName;
              user.combinationName = `${this.userData.targetOrgName}-${user.fullname}`;
            }
            if (this.enableGroupCorp && this.isOrgSelectAlone) {
              // 集团版环境下，选人组件可设置成独立选人，及各个orgId下的相同一个人可以独立选择，并重置每一项的数据的org为当前选择的org
              user.oldId = user.id;
              user.id = `${user.id}&&${this.userData.targetOrgId}`;
            }
            delete this.selectedPersons[user.id];
          });
          this.updateUsers(list, false);
        });
    },
    searchAll() {
      if (this.isCancelSelect) {
        return this.cancelSelectAll();
      }
      const limitCount = 5000;
      let count = 0;
      const len = Math.ceil(this.count / limitCount);
      if (len > 0) {
        this.isSearchAll = true;
      }
      let postData = Object.assign({}, this.userData, { limit: limitCount });
      for (let i = 0; i < len; i++) {
        getUserList(Object.assign({}, postData, { offset: limitCount * i }))
          .then(result => {
            const list = result.datas;
            count++;
            if (count >= len) {
              this.isCancelSelect = true;
              this.isSearchAll = false;
            }
            list.forEach(user => {
              user.nodeType = this.type;
              if (this.enableGroupCorp) {
                user.orgId = this.userData.targetOrgId;
                user.orgName = this.userData.targetOrgName;
                user.combinationName = `${this.userData.targetOrgName}-${user.fullname}`;
              }
              if (this.enableGroupCorp && this.isOrgSelectAlone) {
                // 集团版环境下，选人组件可设置成独立选人，及各个orgId下的相同一个人可以独立选择，并重置每一项的数据的org为当前选择的org
                user.oldId = user.id;
                user.id = `${user.id}&&${this.userData.targetOrgId}`;
              }
              this.selectedPersons[user.id] = user;
            });

            this.updateUsers(list, true);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    checkStatus() {
      if (this.value.length === 0) {
        this.isCancelSelect = false;
      }
      this.users.forEach(user => {
        if (this.selectedPersons.hasOwnProperty(user.id)) {
          this.$refs['userTable'].toggleRowSelection(user, true);
        } else {
          this.$refs['userTable'].toggleRowSelection(user, false);
        }
      });
    },
    search() {
      this.userData.searchKey = this.searchValue;
      this.userData.offset = 0;
      this.page = 1;
      this.showMoreFilter = false;
      this.getUserData();
    },
    itemChange() {
      this.$forceUpdate();
    },
    paramDataChange(type, data) {
      this.selectedParams.forEach(item => {
        if (item.db === type) {
          item.data = data;
        }
      });
    },
    showFilter() {
      this.showMoreFilter = false;
      this.dialogVisible = true;
    },
    saveFilter() {
      if (this.filerName.trim() === '') {
        this.$message({
          type: 'error',
          message: this.$t('pc_biz_udp_msg_filterNameEmpty')
        });
      }
      this.loading = true;
      this.spares.forEach(i=>{
        this.postData[i.nameKey] = {
          ...i,
          list: null
        };
      });
      let fn = this.filterId
        ? editFilter.bind(this, this.filterId, this.postData, this.enableGroupCorp)
        : createFilter.bind(this, this.postData, this.enableGroupCorp);
      fn()
        .then(() => {
          this.loading = false;
          this.dialogVisible = false;
          if (!this.filterId) {
            this.filerName = '';
          }
          this.getFilterList();
        })
        .catch(e => {
          this.loading = false;
          if (e.error && e.error.key === 'apis.udp.filter.validation.name.alreadyExist') {
            this.$message({
              type: 'error',
              message: this.$t('pc_biz_udp_msg_filterNameSame')
            });
          } else {
            console.log(e);
          }

        });
    },
    selectFilter(filter) {
      this.filerName = filter.name;
      this.filterId = filter.id;
      this.loading = true;
      getFilterDetail(filter.id, this.enableGroupCorp)
        .then(item => {
          this.loading = false;
          this.depts = item.deptList;
          this.positions = item.positionList;
          let result = this.params
            .map(param => {
              if (param.db === 'hireDate' || param.db === 'birthday') {
                return Object.assign({}, param, {
                  // 处理部分date格式化部分没有的问题
                  data: [
                    item[param.db + 'Start'] || '',
                    item[param.db + 'End'] || ''
                  ]
                });
              } else if (param.db === 'gradeIds') {
                let gradeList = item.gradeList;
                return Object.assign({}, param, {
                  data: gradeList.map(grade => grade.id)
                });
              } else {
                return Object.assign({}, param, { data: item[param.db] });
              }
            });
          this.getFilterSpares(item);
          this.selectedParams = result;
          this.search();
          this.$forceUpdate();
        })
        .catch(e => {
          this.$message({
            type: 'error',
            message: e.error.key
          });
        });
    },
    deleteFilter(item) {
      deleteFilter(item.id, this.enableGroupCorp)
        .then(() => {
          this.getFilterList();
        })
        .catch(e => {
          this.$message({
            type: 'error',
            message: e.error.key
          });
        });
    },
    selectAllUser(items) {
      let isAdd = items.length !== 0;
      this.users.forEach(user => {
        user.orgName = this.userData.targetOrgName;
        if (this.enableGroupCorp && this.userData.targetOrgName) user.combinationName = `${this.userData.targetOrgName}-${user.fullname}`;
        if (!isAdd) {
          delete this.selectedPersons[user.id];
        } else {
          this.selectedPersons[user.id] = user;
        }
      });

      this.updateUsers(this.users, isAdd);
    },
    selectUser(item, row) {
      let isAdd = item.some(v => {
        return v.id === row.id;
      });
      if (item.length === 0) {
        isAdd = false;
        delete this.selectedPersons[row.id];
      } else {
        this.selectedPersons[row.id] = row;
      }
      row.orgName = this.userData.targetOrgName;
      if (this.enableGroupCorp && this.userData.targetOrgName) row.combinationName = `${this.userData.targetOrgName}-${row.fullname}`;
      this.updateUsers(row, isAdd);
    },
    sizeChange(size) {
      this.userData.limit = size;
      this.page = 1;
      this.userData.offset = 0;
      this.getUserData();
    },
    updateUsers(items, isAdd) {
      this.$emit('input', Object.values(this.selectedPersons));
      this.$emit('update', this.type, items, isAdd);
    },
    pageChange(page) {
      this.page = page;
      this.userData.offset = (page - 1) * this.userData.limit;
      this.getUserData();
    },
    formatSelectedFromData(datas) {
      return [].concat(datas).map((data) => {
        if (data.db === 'hireDate' || data.db === 'birthday') {
          return {
            ...data,
            data: [data.start || '', data.end || '']
          };
        }
        return data;
      });
    },
    async getOrgSpares() {
      try {
        const { datas } = await getOrgSparsByUser();
        this.spares = datas.map(i=>{
          return i.type === 'date' ? {
            basicFlag: 1,
            id: i.id,
            nameKey: i.spareKey, // 扩展字key
            patternRelation: 3, // 日期介于
            patternType: 1, // 0 选项 1日期 2数值
            patternValues: [],
            name: i.name
          } : {
            basicFlag: 1,
            id: i.id,
            nameKey: i.spareKey, // 扩展字key
            patternRelation: 1, // 选项属于
            patternType: 0, // 0 选项 1日期 2数值
            list: i.optionValue ? i.optionValue.split(',') : [],
            patternValues: [],
            name: i.name
          };
        });
        // datas.forEach(i=>{
        //   this.spareForm[i.spareKey] = i.type === 'date' ? {
        //     nameKey: i.spareKey, // 扩展字key
        //     patternRelation: 3, // 日期介于
        //     patternType: 1, // 0 选项 1日期 2数值
        //     patternValues: [],
        //     name: i.name
        //   } : {
        //     nameKey: i.spareKey, // 扩展字key
        //     patternRelation: 1, // 选项属于
        //     patternType: 0, // 0 选项 1日期 2数值
        //     list: i.optionValue ? i.optionValue.split(',') : [],
        //     patternValues: [],
        //     name: i.name
        //   };
        // });
      } catch (e) {
        this.spares = [];
      }
    },
    getFilterSpares(filter) {
      this.spares.forEach(i=>{
        if (!filter[i.nameKey]) return; // 跳过本次循环
        const filterSpare = filter[i.nameKey];
        if (i.patternType === 0) i.patternValues = i.list.filter(v=>filterSpare.patternValues.includes(v));
        else if (i.patternType === 1) i.patternValues = filterSpare.patternValues;
      });
      console.log(this.spares);
    }
  },
  watch: {
    value(v) {
      this.formatUsers(v);
      this.checkStatus();
    },
    depts(depts) {
      this.deptObj = {};
      depts.forEach(dept => {
        this.deptObj[dept.id] = dept;
      });

      // this.$refs.tree.setCheckedKeys(Object.keys(this.deptObj));
    },
    positions(positions) {
      this.positionObj = {};
      positions.forEach(position => {
        this.positionObj[position.id] = position;
      });

      // this.$refs.tree.setCheckedKeys(Object.keys(this.positionObj));
    },
    isShowDeptment(v) {},
    searchValue(value) {
      if (value.length > 20) {
        this.searchValue = value.substring(0, 20);
      }
    }
  }
};
</script>


<style lang="scss">
.yxtbiz-user-selector-filter-block .yxt-form-item__label{
  display: block !important;
}
</style>